import Q from 'q';

import API from 'js/lib/api';

import type { BotManagerTokenData } from 'bundles/authentication/shared/types/sharedTypes';

export type LoginAPIProps = {
  email?: string;
  password?: string;
  verificationCode?: string;
  redirectTo?: string; // redirect url
} & BotManagerTokenData;

export default ({
  email,
  password,
  verificationCode: code,
  botManagerToken,
  botManagerType,
  botManagerError,
  redirectTo,
}: LoginAPIProps) => {
  // We need to set the type to rest to send the body back as a json object instead of form data
  const api = API('', { type: 'rest' });

  const data = {
    email,
    password,
    code,
    botManagerToken,
    botManagerType,
    ...(botManagerError ? { botManagerError } : null),
    redirectTo,
    webrequest: true,
  };

  return Q(api.post('api/login/v3', { data }));
};
